import React from 'react'
import { observer } from 'mobx-react'
import scrollToTop from 'decorators/scrollToTop'
import Link from 'components/Link'
import './styles.sass'
import links from 'misc/links'
import trackUrlConversion from 'utils/trackUrlConversion'

@scrollToTop
@observer
export default class WizardCompletedStep extends React.Component {
  render () {
    const { step } = this.props
    return (
      <div className="wizard-completed-step">
        <div className="container">
          <div className="columns">
            <div className="column is-8 is-offset-2 has-text-centered animated fadeIn">
              <div className="icon-container has-spacing-bottom">
                <img src={require('assets/img/checkmark.png')} className="checkmark-icon animated zoomIn"/>
              </div>
              <h1 className="title is-3 is-semibold is-blue">Thank you for using Taxfyle!</h1>
              <div className="content has-spacing-bottom--less">
                <div>
                  A <strong>Pro</strong> will be in touch with you soon.
                  {step.showPersonalFilingTip &&
                    <span> By the way,we can also file your personal taxes for you.</span>
                  }
                </div>
              </div>
              <div className="content has-spacing-bottom--less">
                <div>
                  The contact email address we have on file
                  is <strong>{step.currentUser.email}</strong> - if this isn't
                  correct, or you can no longer access this email address, please <a onClick={step.showEmailDialog}>click here to change it</a>.
                </div>
              </div>
              <div className="has-spacing-top">
                <Link className="button is-awesome has-chevron-right" to={links.projectDetails(step.job.id)}>Go to chat</Link>
              </div>
              <hr className="has-spacing-top"/>
              <div className="has-spacing-top">
                <h1 className="title is-4 is-semibold is-blue">Get notified!</h1>
                <div className="content">
                  If you haven't already, we recommend you download the <strong>Taxfyle App</strong> so you will
                  get notifications from your Pro, as well as chat &amp; upload documents on the go.
                </div>
                <div className="app-download-buttons">
                  <a
                    onClick={() => trackUrlConversion()}
                    href="https://itunes.apple.com/us/app/taxfyle/id1058033104?mt=8"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                   <img src={require('assets/img/download-appstore.png')}/>
                 </a>
                  &nbsp;
                  <a
                    onClick={() => trackUrlConversion()}
                    href="https://play.google.com/store/apps/details?id=com.taxfyle.TaxfyleMobile"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Get it on Google Play"
                      src={require('assets/img/download-googleplay.png')}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/WizardCompleted/index.jsx